import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addMachine } from 'slice/machineSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AddMachine = () => {
    const [formData, setFormData] = useState({
        name: '',
        price: '',
        unit: '',
        stock_quantity: '',
        description: '',
        image: null,
    });

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.machine);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'file' ? e.target.files[0] : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            formDataToSend.append(key, formData[key]);
        });

        dispatch(addMachine(formDataToSend));
        toast.success('Machine added successfully!');
        navigate('/machine');
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Add Machine</h4>
            </div>
            <form onSubmit={handleSubmit} className="form-style">
                <div className="row mx-4 mt-5">
                    {/* Name */}
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="machineName" className="lables">
                            Name
                        </label>
                        <input
                            type="text"
                            id="machineName"
                            name="name"
                            value={formData.name}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Price */}
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="priceInput" className="lables">
                            Price
                        </label>
                        <input
                            type="number"
                            id="priceInput"
                            name="price"
                            value={formData.price}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Unit */}
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="unitInput" className="lables">
                            Unit (e.g. Piece, Set)
                        </label>
                        <input
                            type="text"
                            id="unitInput"
                            name="unit"
                            value={formData.unit}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Stock Quantity */}
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="stockInput" className="lables">
                            Stock Quantity
                        </label>
                        <input
                            type="number"
                            id="stockInput"
                            name="stock_quantity"
                            value={formData.stock_quantity}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Description */}
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="descInput" className="lables">
                            Description
                        </label>
                        <textarea
                            id="descInput"
                            rows={5}
                            name="description"
                            value={formData.description}
                            className="form-control"
                            onChange={handleChange}
                        ></textarea>
                    </div>

                    {/* Image */}
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="machineImage" className="lables">
                            Image
                        </label>
                        <input
                            type="file"
                            id="machineImage"
                            name="image"
                            className="form-control btn btn-primary"
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="mt-5 text-right mx-4">
                    <button className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Adding...' : 'Add'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddMachine;
